import * as React from 'react';
import { FunctionComponent, useState, useEffect } from 'react';
import { AppUser } from 'Src/views/App/App';
import { UserSignature, getUserSignatures } from 'Src/helpers/service/admin/userSignatures';
import { UserSignatureManager } from '../UserSignatureManager/UserSignatureManager';

interface Props {
  user: AppUser;
  onInsert: (html: string) => void;
}

export const UserSignatureInsert: FunctionComponent<Props> = ({ user, onInsert }) => {
  const [signatures, setSignatures] = useState<UserSignature[]>([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isManagerOpen, setIsManagerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const load = () => {
    setIsLoading(true);
    getUserSignatures(user)
      .then(sigs => {
        setSignatures(sigs);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const handleDropdownToggle = () => {
    if (!isDropdownOpen) load();
    setIsDropdownOpen(prev => !prev);
  };

  const handleInsert = (sig: UserSignature) => {
    onInsert(sig.htmlContent);
    setIsDropdownOpen(false);
  };

  const handleManagerClose = () => {
    setIsManagerOpen(false);
    load();
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={handleDropdownToggle}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '4px 12px',
          borderRadius: '4px',
          border: '1px solid #cbd5e1',
          background: isDropdownOpen ? '#f0f4ff' : '#fff',
          color: '#374151',
          fontSize: '13px',
          fontWeight: 500,
          cursor: 'pointer',
          transition: 'all 0.15s'
        }}
      >
        ✍️ Insert signature
        <span style={{ fontSize: '10px', marginLeft: '2px' }}>▾</span>
      </button>

      {isDropdownOpen && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            zIndex: 1000,
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            minWidth: '240px',
            maxWidth: '320px'
          }}
        >
          {isLoading && <div style={{ padding: '12px 16px', color: '#64748b', fontSize: '13px' }}>Loading...</div>}
          {!isLoading && signatures.length === 0 && (
            <div style={{ padding: '12px 16px', color: '#64748b', fontSize: '13px' }}>No signatures yet.</div>
          )}
          {!isLoading &&
            signatures.map(sig => (
              <div
                key={sig._id}
                onClick={() => handleInsert(sig)}
                style={{
                  padding: '10px 16px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#1e293b',
                  borderBottom: '1px solid #f1f5f9',
                  transition: 'background 0.1s'
                }}
                onMouseEnter={e => (e.currentTarget.style.background = '#f8fafc')}
                onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
              >
                <div>{sig.name}</div>
                {sig.htmlContent && (
                  <div
                    style={{
                      fontSize: '11px',
                      color: '#94a3b8',
                      marginTop: '2px',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                    dangerouslySetInnerHTML={{ __html: sig.htmlContent.replace(/<[^>]+>/g, ' ').substring(0, 60) }}
                  />
                )}
              </div>
            ))}
          <div
            onClick={() => {
              setIsDropdownOpen(false);
              setIsManagerOpen(true);
            }}
            style={{
              padding: '10px 16px',
              cursor: 'pointer',
              fontSize: '12px',
              color: '#3b5bdb',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            onMouseEnter={e => (e.currentTarget.style.background = '#f8fafc')}
            onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
          >
            ⚙️ Manage signatures
          </div>
        </div>
      )}

      {/* Закрывать дропдаун при клике вне */}
      {isDropdownOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 999 }} onClick={() => setIsDropdownOpen(false)} />
      )}

      <UserSignatureManager user={user} isOpen={isManagerOpen} onClose={handleManagerClose} />
    </div>
  );
};

UserSignatureInsert.displayName = 'UserSignatureInsert';
